var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickValidicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Tick_Valid_icon",
    "data-name": "Tick Valid icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.774,
    height: 11.83,
    viewBox: "0 0 15.774 11.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14162",
    "data-name": "Path 14162",
    d: "M450.315,477.061l-1.972,1.972-1.972-1.972-3.943-3.943,1.972-1.972,3.943,3.943,7.887-7.887,1.972,1.972Z",
    transform: "translate(-442.429 -467.203)",
    fill: "#56aa1c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickValidicon);
export default __webpack_public_path__ + "static/media/Tick Valid icon.f2f745694ad5407a42b90f4f9ffd32d6.svg";
export { ForwardRef as ReactComponent };